import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import {
    errorCardHeader,
    infoCardHeader, noticeCardHeader, primaryCardHeader,
    secondaryCardHeader, successCardHeader, warningCardHeader
} from "./cardCommon";

const cardIconStyle = (theme: Theme) => createStyles({
    noticeCardHeader: {
        ...noticeCardHeader(theme),
    },

    warningCardHeader: {
        ...warningCardHeader(theme),
    },
    successCardHeader: {
        ...successCardHeader(theme)
    },
    errorCardHeader: {
        ...errorCardHeader(theme)
    },
    infoCardHeader: {
        ...infoCardHeader(theme)
    },
    primaryCardHeader: {
        ...primaryCardHeader(theme)
    },
    secondaryCardHeader: {
        ...secondaryCardHeader(theme)
    },

    cardIcon: {
        "&$warningCardHeader,&$successCardHeader,&$errorCardHeader,&$infoCardHeader,&$primaryCardHeader": {
            borderRadius: "3px",
            backgroundColor: "#999",
            padding: "15px",
            marginTop: "-20px",
            marginRight: "15px",
            float: "left"
        }
    },
});

export default cardIconStyle;
